import _ from 'lodash';

import { LendingAPIProvider } from './LendingAPIProvider';
import { LendingAPIProviderDE } from './LendingAPIProviderDE';

function getConstructor(countryCode) {
    switch (countryCode) {
        case 'de':
            return LendingAPIProviderDE;
        default:
            return LendingAPIProvider;
    }
}
const lendingAPIProvidersSingleton = {};

export function getInstance(countryCode) {
    if (!_.get(lendingAPIProvidersSingleton, countryCode + 'instance')) {
        let Constructor = getConstructor(countryCode);
        lendingAPIProvidersSingleton[countryCode + 'instance'] =
            new Constructor();
    }

    return lendingAPIProvidersSingleton[countryCode + 'instance'];
}
